export default function animationsComponent() {
    return {
        observer: null,

        init() {
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const target = entry.target;
                            const baseDelay = parseFloat(target.getAttribute("data-delay")) || 0; // Default delay
                            const staggerIncrement = 0.18; // 0.25s incremental delay
                            const animateChildren = target.hasAttribute("data-animate-elements"); // Should we animate children?

                            if (animateChildren) {
                                // Get all direct children
                                const children = Array.from(target.children);
                                
                                children.forEach((child, index) => {
                                    child.style.animationDelay = `${baseDelay + index * staggerIncrement}s`;
                                    child.classList.add("animate-effect-in");
                                });
                            } else {
                                // Apply animation to the parent itself if `data-animate-elements` is NOT present
                                target.style.animationDelay = `${baseDelay}s`;
                                target.classList.add("animate-effect-in");
                            }

                            this.observer.unobserve(target); // Stop observing after animation starts
                        }
                    });
                },
                {
                    rootMargin: "0px 0px -150px 0px", // Ensure 100px is visible before triggering
                    threshold: 0,
                }
            );

            // Apply hidden state immediately on load to prevent flashing
            document.querySelectorAll("[data-animate]").forEach((el) => {
                if (el.hasAttribute("data-animate-elements")) {
                    // Only hide child elements if `data-animate-elements` is present
                    el.querySelectorAll(":scope > *").forEach((child) => {
                        child.style.opacity = "0"; // Hide children initially
                        child.style.transform = "translateY(50px)";
                    });
                } else {
                    el.style.opacity = "0"; // Hide parent initially
                    el.style.transform = "translateY(50px)";
                }
                this.observer.observe(el);
            });
        },
    };
}